import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { ApiResponse } from './../../../core/models/response-api';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PermissionService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}/api`);
  }

  getListPermissionsRole() {
    return this._http.get<ApiResponse<any>>(this._base + `/Permission/getAll`);
  }
  /* get list permissiions by role */
  getListPermissionsByRole(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Permission/getByRole?role_id=${id}`
    );
  }
  /* give permission  */
  assignPermission(data: { role_id: number; permission_ids: number[] }) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/CompanyRoles/AssignRemove`,
      data
    );
  }

  /* search permission */
  searchPermission(id: number, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/CompanyRoles/searchPermission?employee_role_id=${id}`,
      data
    );
  }
  /* search permission */
  getPermissionByRole(id: number | undefined) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Offer/getPermissionsAssignedToAbonnement?offer_id=${id}`
    );
  }
  /* get list permissions */
  getListPermissions(company_id: any, employee_role_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/CompanyRoles/getPermissionByRole?company_id=${company_id}&employee_role_id=${employee_role_id}`
    );
  }
}
